import {
	AcquisitionEvaluationStage,
	AcquisitionEvaluationStageMap,
	AcquisitionTransactionType,
	AcquisitionTransactionTypeMap,
	BaseRateTypes,
	BaseRateTypesMap,
	CompanyFinancialStatementTypes,
	CompanyFinancialStatementTypesMap,
	CompanySubscriptionStatus,
	CompanySubscriptionStatusMap,
	ControlledObjectType,
	CountryTypeMap,
	CountryTypes,
	CovenantTargetTypes,
	CovenantTargetTypesMap,
	CurrentUser,
	DealStatus,
	DealStatuses,
	FacilityAmortizationPeriods,
	FacilityAmortizationPeriodsMap,
	FacilityAvailabilityLimitTypes,
	FacilityAvailabilityLimitTypesMap,
	InterestRateTypes,
	InterestRateTypesMap,
	InvoiceStatus,
	InvoiceStatusMap,
	NatureOfBuyerType,
	NatureOfBuyerTypeMap,
	PaymentScheduleType,
	PaymentScheduleTypeMap,
	ProductCategory,
	ProductCategoryMap,
	ProfileRealEstateType,
	ProfileRealEstateTypeMap,
	ProfileTangibleAssetType,
	ProfileTangibleAssetTypeMap,
	RateTypes,
	RateTypesMap,
	StructureTrancheMap,
	StructureTranches,
	SubscriptionFrequency,
	SubscriptionFrequencyMap,
	TermSheetFeeFrequencies,
	TermSheetFeeFrequenciesMap,
	TermSheetFeeTypes,
	TermSheetFeeTypesMap,
	Tier1BankTypeMap,
	Tier1BankTypes,
	Tier2BankTypeMap,
	Tier2BankTypes,
	Tier3ContactTypeMap,
	Tier3ContactTypes,
	TypicalCreditSpreadTypeMap,
	TypicalCreditSpreadTypes,
} from '../models';
import {
	CollateralSecurityTypeMap,
	CollateralSecurityTypes,
	FacilityTypeMap,
	FacilityTypes,
	LenderTypeMap,
	LenderTypes,
	MaturityQuarterTypeMap,
	MaturityQuarterTypes,
} from '../models/DealDebtSchedule';
import { LoanOptionType, LoanOptionTypeMap } from '../models/DealTypePreference';
import {
	ApplicationTaskStatusType,
	ApplicationTaskStatusTypeMap,
	LoanApplicationTaskType,
	LoanApplicationTaskTypeMap,
} from '../models/LoanApplicationTask';
import {
	OutputAnalysisGroup,
	OutputAnalysisGroupMap,
	OutputAnalysisStatus,
	OutputAnalysisStatusMap,
	OutputAnalysisType,
	OutputAnalysisTypeMap,
	SummaryOutputStatus,
	SummaryOutputStatusMap,
} from '../models/OutputAnalysisStructure';

export function GetProductCategoryDescription(enumValue: ProductCategory | null | undefined): string | null {
	if (enumValue == null) return null;
	return ProductCategoryMap[enumValue];
}

export function GetSubscriptionFrequencyDescription(
	enumValue: SubscriptionFrequency | null | undefined
): string | null {
	if (enumValue == null) return null;
	return SubscriptionFrequencyMap[enumValue];
}

export function GetCompanySubscriptionStatusDescription(
	enumValue: CompanySubscriptionStatus | null | undefined
): string | null {
	if (enumValue == null) return null;
	return CompanySubscriptionStatusMap[enumValue];
}

export function GetDealStatusDescription(enumValue: DealStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return DealStatuses[enumValue];
}

export function GetStructureTrancheDescription(enumValue: StructureTranches | null | undefined): string | null {
	if (enumValue == null) return null;
	return StructureTrancheMap[enumValue];
}

export function GetTier1BankTypeDescription(enumValue: Tier1BankTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return Tier1BankTypeMap[enumValue];
}

export function GetTypicalCreditSpreadTypeDescription(
	enumValue: TypicalCreditSpreadTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return TypicalCreditSpreadTypeMap[enumValue];
}

export function GetFacilityTypeDescription(enumValue: FacilityTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return FacilityTypeMap[enumValue];
}

export function GetLenderTypeDescription(enumValue: LenderTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return LenderTypeMap[enumValue];
}

export function GetMaturityQuarterTypeDescription(enumValue: MaturityQuarterTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return MaturityQuarterTypeMap[enumValue];
}

export function GetCollateralSecurityTypeDescription(
	enumValue: CollateralSecurityTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return CollateralSecurityTypeMap[enumValue];
}

export function GetProfileTangibleAssetTypeDescription(
	enumValue: ProfileTangibleAssetType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return ProfileTangibleAssetTypeMap[enumValue];
}

export function GetNatureOfBuyerTypeDescription(enumValue: NatureOfBuyerType | null | undefined): string | null {
	if (enumValue == null) return null;
	return NatureOfBuyerTypeMap[enumValue];
}

export function GetAcquisitionTransactionTypeDescription(
	enumValue: AcquisitionTransactionType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return AcquisitionTransactionTypeMap[enumValue];
}

export function GetAcquisitionEvaluationStageDescription(
	enumValue: AcquisitionEvaluationStage | null | undefined
): string | null {
	if (enumValue == null) return null;
	return AcquisitionEvaluationStageMap[enumValue];
}

export function GetProfileRealEstateTypeDescription(
	enumValue: ProfileRealEstateType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return ProfileRealEstateTypeMap[enumValue];
}

export function GetCountryTypeDescription(enumValue: CountryTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return CountryTypeMap[enumValue];
}

export function GetOutputAnalysisGroupDescription(enumValue: OutputAnalysisGroup | null | undefined): string | null {
	if (enumValue == null) return null;
	return OutputAnalysisGroupMap[enumValue];
}

export function GetOutputAnalysisTypeDescription(enumValue: OutputAnalysisType | null | undefined): string | null {
	if (enumValue == null) return null;
	return OutputAnalysisTypeMap[enumValue];
}

export function GetOutputAnalysisStatusDescription(enumValue: OutputAnalysisStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return OutputAnalysisStatusMap[enumValue];
}

export function GetSummaryOutputStatusDescription(enumValue: SummaryOutputStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return SummaryOutputStatusMap[enumValue];
}

export function GetApplicationTaskStatusDescription(
	enumValue: ApplicationTaskStatusType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return ApplicationTaskStatusTypeMap[enumValue];
}

export function GetLoanApplicationTaskTypeDescription(
	enumValue: LoanApplicationTaskType | null | undefined
): string | null {
	if (enumValue == null) return null;
	return LoanApplicationTaskTypeMap[enumValue];
}

export function GetPaymentScheduleTypeValue(enumValue: Number | null | undefined) : PaymentScheduleType | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 10:
			return 'Now';
		case 12:
			return 'Net7';
		case 15:
			return 'Net15';
		case 20:
			return 'Net30';
		case 30:
			return 'Net60';
		case 99:
			return 'Custom';
		default:
			return null;
	}
}

export function GetTier1BankTypeValue(enumValue: Tier1BankTypes | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'Commercial':
			return 10;
		case 'NonBank':
			return 20;
		case 'Other':
			return 99;
		default:
			return null;
	}
}

export function GetTier2BankTypeDescription(enumValue: Tier2BankTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return Tier2BankTypeMap[enumValue];
}

export function GetTier2BankTypeValue(enumValue: Tier2BankTypes | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'International':
			return 101;
		case 'National':
			return 102;
		case 'Regional':
			return 103;
		case 'CreditUnion':
			return 104;
		case 'CommunityBank':
			return 105;
		case 'Sblc':
			return 106;
		case 'Sbic':
			return 201;
		case 'Bdc':
			return 202;
		case 'DirectLender':
			return 203;
		case 'VentureLender':
			return 204;
		case 'AssetBased':
			return 205;
		case 'FamilyOffice':
			return 206;
		case 'PrivateEquity':
			return 207;
		default:
			return null;
	}
}

export function GetTier3ContactTypeDescription(enumValue: Tier3ContactTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return Tier3ContactTypeMap[enumValue];
}

export function GetPaymentScheduleTypeDescription(enumValue: PaymentScheduleType | null | undefined): string | null {
	if (enumValue == null) return null;
	return PaymentScheduleTypeMap[enumValue];
}

export function GetInvoiceStatusDescription(enumValue: InvoiceStatus | null | undefined): string | null {
	if (enumValue == null) return null;
	return InvoiceStatusMap[enumValue];
}

export function GetTier3ContactTypeValue(enumValue: Tier3ContactTypes | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'Sba7a':
			return 1;
		case 'Sba504':
			return 2;
		case 'SeniorCash':
			return 4;
		case 'AssetWorkingCapital':
			return 8;
		case 'AssetEquipment':
			return 16;
		case 'RealEstateSenior':
			return 32;
		case 'MiddleMarket':
			return 64;
		case 'LeveragedFinance':
			return 128;
		case 'SyndicatedCapitalMarkets':
			return 256;
		case 'JuniorCash':
			return 512;
		case 'Mezzanine':
			return 1024;
		case 'StructuredPrivateEquity':
			return 2048;
		case 'RealEstateJunior':
			return 4096;
		case 'EquityMinority':
			return 16384;
		case 'EquityControl':
			return 32768;
		case 'UnitrancheStretchSenior':
			return 65536;
		case 'VentureCapital':
			return 131072;
		case 'MiddleMarketSpecialist':
			return 262144;
		case 'AssetIntangible':
			return 524288;
		case 'Usda':
			return 1048576;
		case 'VentureDebt':
			return 2097152;
		case 'RecurringRevenue':
			return 4194304;
		default:
			return null;
	}
}

export function GetStructureTrancheValue(enumValue: StructureTranches | null | undefined): number | null {
	if (enumValue == null) return null;
	switch (enumValue) {
		case 'SeniorCashFlow':
			return 1;
		case 'JuniorCashFlow':
			return 2;
		case 'VentureDebt':
			return 3;
		case 'Equity':
			return 4;
		case 'SeniorRealEstate':
			return 5;
		case 'JuniorRealEstate':
			return 6;
		case 'Sba7aRealEstate':
			return 7;
		case 'Sba7aNonRealEstate':
			return 8;
		case 'Sba504Senior':
			return 9;
		case 'Sba504Debenture':
			return 10;
		case 'UsdaBiRealEstate':
			return 11;
		case 'UsdaBiEquipment':
			return 12;
		case 'UsdaBiWorkingCapital':
			return 13;
		case 'AssetBasedWorkingCapitalAccountsReceivable':
			return 14;
		case 'AssetBasedWorkingCapitalInventory':
			return 15;
		case 'AssetBasedEquipmentMachinery':
			return 16;
		case 'AssetBasedEquipmentVehicles':
			return 17;
		case 'AssetBasedEquipmentMarine':
			return 18;
		case 'AssetBasedEquipmentHelicopters':
			return 19;
		case 'AssetBasedEquipmentAircraft':
			return 20;
		case 'AssetBasedIntangibleIntellectualProperty':
			return 21;
		case 'AssetBasedIntangibleRoyalty':
			return 22;
		case 'PoFinancing':
			return 24;
		case 'Factoring':
			return 25;
		case 'RecurringRevenue':
			return 26;
		case 'InventoryOnly':
			return 27;
		case 'LenderFinance':
			return 28;
		case 'FloorplanFinance':
			return 29;
		case 'AssetBasedWorkingCapitalArPlusInventory':
			return 30;
		case 'BridgeLoan':
			return 31;
		default:
			return null;
	}
}

export function GetLoanOptionType(enumValue: LoanOptionType | null | undefined): string {
	if (enumValue == null) return '';
	return LoanOptionTypeMap[enumValue];
}

export function HasControlledObject(user: CurrentUser, type: ControlledObjectType): boolean {
	if (user.isEmployeeUser && user.controlledObjects && user.controlledObjects.length > 0) {
		const permission = user.controlledObjects.filter(obj => obj.type == type && obj.hasAccess);
		return permission != null && permission.length > 0;
	}

	return false;
}

export function GetCovenantTargetTypeDescription(enumValue: CovenantTargetTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return CovenantTargetTypesMap[enumValue];
}

export function GetRateTypesDescription(enumValue: RateTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return RateTypesMap[enumValue];
}

export function GetInterestRateTypesDescription(enumValue: InterestRateTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return InterestRateTypesMap[enumValue];
}

export function GetBaseRateTypesDescription(enumValue: BaseRateTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return BaseRateTypesMap[enumValue];
}

export function GetTermSheetFeeFrequenciesDescription(
	enumValue: TermSheetFeeFrequencies | null | undefined
): string | null {
	if (enumValue == null) return null;
	return TermSheetFeeFrequenciesMap[enumValue];
}

export function GetCompanyFinancialStatementTypesDescription(
	enumValue: CompanyFinancialStatementTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return CompanyFinancialStatementTypesMap[enumValue];
}

export function GetFacilityAmortizationPeriodsDescription(
	enumValue: FacilityAmortizationPeriods | null | undefined
): string | null {
	if (enumValue == null) return null;
	return FacilityAmortizationPeriodsMap[enumValue];
}

export function GetFacilityAvailabilityLimitTypeDescription(
	enumValue: FacilityAvailabilityLimitTypes | null | undefined
): string | null {
	if (enumValue == null) return null;
	return FacilityAvailabilityLimitTypesMap[enumValue];
}

export function GetTermSheetFeeTypesDescription(enumValue: TermSheetFeeTypes | null | undefined): string | null {
	if (enumValue == null) return null;
	return TermSheetFeeTypesMap[enumValue];
}
